import React from 'react'
import styles from './UIGamePortraitTop.module.scss'
import {UIGameHelpUserSettingsButtonContainer} from '../UIGameHelpButtons/UIGameHelpButtons.tsx'
import {UIGameEndReturnToStats} from '../UIGameEnd/UIGameEndReturnToStats/UIGameEndReturnToStats.tsx'
import {useGameStore} from '../../store/GameStoreContext.ts'
import clsx from 'clsx'
import {useIsGameEnded} from '../../store/selectors/useIsGameEnded.ts'
import {UIGameBankPortrait} from '../UIGameBankPortrait/UIGameBankPortrait.tsx'
import {useBankCardStackSizes} from '../UIGameBank/useBankCardStackSizes.ts'
import {useBankCardState} from '../UIGameBank/useBankCardState.ts'
import {UIGameHelpInformationButton} from '../UIGameHelpButtons/UIGameHelpInformationButton/index.ts'
import {UIGamePlayerInfoToggle} from '../UIGamePlayerInfoToggle/UIGamePlayerInfoToggle.tsx'
import IconUsedDevs from '@static/images/icon_used_devs.svg'
import IconCK from '@static/images/player_info_toggle_ck_icon.svg'
import {UIGamePlayerInfoToggleContentPieces} from '../UIGamePlayerInfoToggle/UIGamePlayerInfoToggleContentPieces.tsx'
import {useMyPerspectiveColor} from '../../store/selectors/useMyPerspectiveColor.ts'
import {ModeSettingEnum} from '@colonist/types'

interface UIGamePortraitTopProps {
    isPlayerInfoSectionUsedDevsActive: boolean
    setIsPlayerInfoSectionUsedDevsActive: (isActive: boolean) => void
    isPlayerInfoSectionCKActive: boolean
    setIsPlayerInfoSectionCKActive: (isActive: boolean) => void
    isPlayerInfoSectionPiecesActive: boolean
    setIsPlayerInfoSectionPiecesActive: (isActive: boolean) => void
    initialCanResign: boolean
    className?: string
}

export const UIGamePortraitTop = ({
    isPlayerInfoSectionUsedDevsActive,
    setIsPlayerInfoSectionUsedDevsActive,
    isPlayerInfoSectionCKActive,
    setIsPlayerInfoSectionCKActive,
    isPlayerInfoSectionPiecesActive,
    setIsPlayerInfoSectionPiecesActive,
    initialCanResign,
    className,
}: UIGamePortraitTopProps) => {
    const modeSetting = useGameStore((state) => state.gameSettings.modeSetting)
    const isBeginnerMode = modeSetting === ModeSettingEnum.BeginnerModeClassic4P
    const isGameEnded = useIsGameEnded()
    const bankCardState = useBankCardState()
    const bankCardStackSizes = useBankCardStackSizes()
    const hideBankCards = useGameStore((state) => state.gameState.bankState.hideBankCards)
    const progressCards = useGameStore((state) => state.gameState.mechanicProgressCardsState?.bankProgressCards)

    const isMechanicIslandExplorationActive = useGameStore((state) => state.gameState.mechanicIslandExplorationState) !== undefined
    const victoryPointsToWin = useGameStore((state) => state.gameSettings.victoryPointsToWin)
    const myPerspectiveColor = useMyPerspectiveColor()

    const isMechanicDevelopmentCardsActive = useGameStore((state) => state.gameState.mechanicDevelopmentCardsState) !== undefined
    const isMechanicCityImprovementsActive = useGameStore((state) => state.gameState.mechanicCityImprovementsState) !== undefined

    return <div className={clsx(styles.topContainerPortrait, className)}>
        {!isGameEnded && <div className={styles.helpButtonsContainer}>
            <div className={styles.settingsButtonContainer}>
                <UIGameHelpUserSettingsButtonContainer
                    className={styles.settingsButton}
                    initialCanResign={initialCanResign}
                    isRulesOptionVisible={true} />
            </div>
            <div className={styles.infoButtonContainer}>
                <UIGameHelpInformationButton
                    className={styles.infoButton}
                    gameMode={modeSetting}
                    isMechanicIslandExplorationActive={isMechanicIslandExplorationActive}
                    playerColor={myPerspectiveColor}
                    victoryPointsToWin={victoryPointsToWin}/>
            </div>
        </div>}
        {isGameEnded && <div className={styles.gameEndReturnToStatsContainer}>
            <UIGameEndReturnToStats text="strings:game.endGame.cornerButton.openStatsMobile" className={styles.gameEndReturnToStatsButton} />
        </div>}
        <div className={styles.gameBankContainer}>
            <UIGameBankPortrait
                cardState={bankCardState}
                cardStackSizes={bankCardStackSizes}
                hideBankCards={hideBankCards}
                modeSetting={modeSetting}
                progressCards={progressCards}
            />
        </div>
        {!isBeginnerMode && <div className={styles.gamePlayerInfoToggleContainer}>
            <UIGamePlayerInfoToggle
                isActive={isPlayerInfoSectionPiecesActive}
                setIsActive={setIsPlayerInfoSectionPiecesActive}>
                <UIGamePlayerInfoToggleContentPieces playerColor={myPerspectiveColor} />
            </UIGamePlayerInfoToggle>
            {isMechanicDevelopmentCardsActive && <UIGamePlayerInfoToggle
                isActive={isPlayerInfoSectionUsedDevsActive}
                setIsActive={setIsPlayerInfoSectionUsedDevsActive}>
                <img src={IconUsedDevs} className={styles.gamePlayerInfoToggleIcon}/>
            </UIGamePlayerInfoToggle>}
            {isMechanicCityImprovementsActive && <UIGamePlayerInfoToggle
                isActive={isPlayerInfoSectionCKActive}
                setIsActive={setIsPlayerInfoSectionCKActive}>
                <img src={IconCK} className={styles.gamePlayerInfoToggleIcon}/>
            </UIGamePlayerInfoToggle>}
        </div>}
    </div>
}
